import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { InputMask } from "@react-input/mask";
function Form() {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        phonenumber: '',
        comments: '',
    });
    const [errors, setErrors] = useState({});
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [btnDisable, setbtnDisable] = useState();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setbtnDisable(true);
        const newErrors = validateForm(formData);
        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0 && recaptchaToken) {
            try {
                const response = await fetch("https://nvgnd9xg5h.execute-api.ap-south-1.amazonaws.com/prod/send-email", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ ...formData, recaptchaToken }),
                });
    
                const data = await response.json();
                if (response.ok) {
                    console.log("Form submitted successfully!", data);
                    setbtnDisable(false)
                    alert("Thank you for contacting SpurTree. One of our representatives will contact you shortly.");
                } else {
                    console.log("Error:", data.error);
                }
            } catch (error) {
                console.error("Error sending email:", error);
                setbtnDisable(false);
            }
        } else {
            console.log("Form submission failed due to validation errors.");
        }
    };

    const validateForm = (data) => {
        const errors = {};
        if (!data.username.trim()) {
            errors.username = 'Username is required';
            setbtnDisable(false);
        } 
        if (!data.email.trim()) {
            errors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(data.email)) {
            errors.email = 'Email is invalid';
            setbtnDisable(false);
        }
        if (!recaptchaToken) {
            errors.recaptcha = 'Please complete the reCAPTCHA';
            setbtnDisable(false);
        }
        return errors;
    };

    return (
        <div className="formSection">
            <div className="container">
                <p>Please complete this short form and a SpurTree representative will contact you.</p>
                <div className="form-container">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="label">Name - <span>required</span></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="username"
                                        value={formData.username}
                                        onChange={handleChange}
                                    />
                                    {errors.username && <span className="error-message">{errors.username}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="label">Email - <span>required</span></label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    {errors.email && <span className="error-message">{errors.email}</span>}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group pr">
                                    <label className="label">Phone Number</label>
                                    {/* <input
                                        className="form-control"
                                        type="number"
                                        name="phonenumber"
                                        value={formData.phonenumber}
                                        onChange={handleChange}
                                    /> */}
                                    <span className="cCode">+1</span>
                                    <InputMask
                                        placeholder="(xxx) xxx-xxxx"
                                        mask="(###) ###-####"
                                        replacement={{ "#": /[0-9]/ }}
                                        maskChar={null}
                                        className="form-control ps-4"
                                        type="text"
                                        name="phonenumber"
                                        value={formData.phonenumber}
                                        onChange={handleChange}
                                    />
                                   
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="label">Comments</label>
                                    <textarea
                                        className="form-control"
                                        rows="5"
                                        name="comments"
                                        value={formData.comments}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <ReCAPTCHA
                                        sitekey="6LcIDuoqAAAAAOooiaC_F29MoZBuyfPbrKscjkTp"
                                        onChange={handleRecaptchaChange}
                                    />
                                    {errors.recaptcha && <span className="error-message">{errors.recaptcha}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <button className="submit-button" type="submit" disabled={btnDisable}> {btnDisable ? "Sending..." : "Submit"}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Form;